module.exports = __webpack_public_path__ + "static/media/s2.2f4b6f73.svg";